import {DaDataResponse} from '../../shared/types/daData.types';

const BASE_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

const REQUEST_INIT = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: 'Token ' + process.env.REACT_APP_DADATA_TOKEN,
  },
} as const;

export const daDataService = {
  async getAddressSuggestions(query: string): Promise<DaDataResponse> {
    const response = await fetch(`${BASE_URL}?query=${query}`, REQUEST_INIT);
    return await response.json();
  },
};
